/**
 * Read-checkmark (double tick) used in outgoing bubbles – WhatsApp read-blue `#53bdeb`.
 *
 * Blatt-Modul ohne jede Abhängigkeit und bewusst OHNE `'use client'`: sowohl die
 * Server-Renderer (`service-page`, `home`, `lp/concierge`) als auch das
 * Client-Modul `ui/whatsapp-phone.tsx` greifen darauf zu. `whatsapp-phone.tsx`
 * re-exportiert das Symbol, damit die Design-Sync-Preview (`previews/ReadCheck.tsx`,
 * importiert aus `@locari/website`) unberührt bleibt. Läge die Definition weiter
 * in `whatsapp-phone.tsx`, entstünde mit `whatsapp-message-bubble.tsx` ein
 * Import-Zyklus (Spec §5.4).
 */
export function ReadCheck() {
  return (
    <svg
      className="read-check"
      viewBox="0 0 18 12"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M1 6.5 4.2 9.7 9.5 3.4" />
      <path d="M7.5 8.6 8.4 9.7 13.9 3" />
    </svg>
  );
}
